<g id="fleur">
  <style type="text/css">
    .st0 {
      fill: #d29d46;
    }
    .st1 {
      fill: url(#SVGID_1_);
    }
    .st2 {
      fill: url(#SVGID_2_);
    }
    .st3 {
      fill: url(#SVGID_3_);
    }
    .st4 {
      fill: none;
    }
  </style>
  <path
    class="st0"
    d="M214.2,385.4c3.5,0,2.1,3.8,1.9,8.5c-0.2,4.7,2.8,3.3,14.6,5.9c3.1,5.7,9.7,7.8,16.3,11.8
		c-1.2,3.3,0.7,10.6,0.7,10.6s-0.7,3.8-6.9,39c-2.9,16.6-10.8,24.7-20.8,28.9h42.4c0.6-0.9,1.1-1.8,1.7-2.7
		c7.6-11.1,14.6-61.1,16-79.1c1.4-18,9.7-11.8,16-15.3c6.2-3.5,4.2-9,4.2-9s2.8-8.3,8.3-16.8c5.6-8.5,24.1-14.3,24.1-14.3l6.1-11.6
		l-57.9-26.7l-45.6,0.9c0,0-37.6,26.4-38.2,47C196.4,383.1,210.8,385.4,214.2,385.4z"
  />
  <linearGradient
    id="SVGID_1_"
    gradientUnits="userSpaceOnUse"
    x1="271.7886"
    y1="319.8925"
    x2="271.7886"
    y2="-36.4957"
  >
    <stop offset="0" style="stop-color:#E7A925" />
    <stop offset="0.1409" style="stop-color:#E1B859" />
    <stop offset="0.2787" style="stop-color:#DBC586" />
    <stop offset="0.3481" style="stop-color:#D9CA97" />
    <stop offset="0.484" style="stop-color:#D8C895" />
    <stop offset="0.533" style="stop-color:#D6C38E" />
    <stop offset="0.5384" style="stop-color:#D6C28D" />
    <stop offset="0.5499" style="stop-color:#D7C492" />
    <stop offset="0.6445" style="stop-color:#E2D5B9" />
    <stop offset="0.7382" style="stop-color:#EBE1D7" />
    <stop offset="0.8298" style="stop-color:#F1EBED" />
    <stop offset="0.9182" style="stop-color:#F5F0FA" />
    <stop offset="1" style="stop-color:#F6F2FE" />
  </linearGradient>
  <path
    class="st1"
    d="M248.6,315.2c0,0-15.9-2-28.6,19.3c-1.4,2.4-3,4.8-4.9,6.9c-16,18-29.6,33.6-58.6,18.1
		c-2.2-1.2-4.3-2.7-6.2-4.3c-15.5-13.3-20.4-22.5-24.6-30.1c-1.9-3.5-4.4-6.6-7.4-9.3c-7.8-7.2-25.2-24.7-34.9-45.5
		c-0.7-1.5-1.5-3-2.3-4.4c-17.9-28.1-36.8-53.1-46.5-92.1c-6.4-23-23.7-90.6,10.8-110.1c19-10.6,26.9-15.9,31.2-17.5
		c6-2.2,11.1-6.2,15.5-10.8c0.4-0.5,0.9-0.9,1.3-1.4c2.7-2.8,5.7-5.3,9.1-7.1c3.8-2.1,9.2-4.4,15.2-5.4c12.1-3.8,14.1-4.9,21.1-4.8
		s15,4.1,20.1,20.1c5.2,16.1,4.8,17.2,4.8,17.2s1.6,6.3,4.8,0.1s20.8-38.1,38.9-38.2c18.1-0.2,20.8,0.2,44.5,28.4
		c3.3,4.2,3,5.4,5.4,5.4c2.4,0,4.5-3.8,6.3-9.4c1.7-5.4,14.6-26,42.5-30.4c2.3-0.4,4.7-0.5,7.1-0.3c33.7,2.2,51,30.1,57,44.4
		c4.3,6.8,1.4-1,3.3-6.3c0.3-0.8,0.8-1.8,1.5-3c23.2-29.5,27.7-20.8,44.1-15.3c6.3,2.1,11.2,3.9,11.2,3.9s10.8,1.6,20.5,19.4
		c9.7,17.8,13.5,23.9,13.5,23.9s1.4,2.5,2.2,2.1c0.8-0.4,0-3.2,0-3.2l-3.3-13.2c0,0-1.7-9.5,6.9-4.5c8.7,4.9,29.4,20.6,29.4,20.6
		S520.8,92,519,125.8c-3.7,34.1-8.1,45.3-27.1,75.3s-42.7,65.1-45.9,74.8c-3.2,9.7-20.5,51.9-40.5,60.5
		c-11.2,7.2-20.8,11.3-30.6,6.8s-11.3-2.7-13.7,0.2c-2.3,2.8-7.5,12.5-22.3,9.5c-14.8-3-22.5-4.7-26.5-4.2
		c-4,0.5-20.8-5.3-32.5-19.8C275.6,324.9,261.1,315.1,248.6,315.2z"
  />
  <linearGradient
    id="SVGID_2_"
    gradientUnits="userSpaceOnUse"
    x1="267.6528"
    y1="367.1317"
    x2="267.6528"
    y2="163.0484"
  >
    <stop offset="0" style="stop-color:#BD4908" />
    <stop offset="4.805058e-02" style="stop-color:#C0540C" />
    <stop offset="0.2001" style="stop-color:#C87115" />
    <stop offset="0.3623" style="stop-color:#CE871D" />
    <stop offset="0.5374" style="stop-color:#D39822" />
    <stop offset="0.7345" style="stop-color:#D5A125" />
    <stop offset="1" style="stop-color:#D6A426" />
  </linearGradient>
  <path
    class="st2"
    d="M120.4,318.5c0,0-27.5-48.8-23.9-83.6c-0.3-13-0.8-15-4.1-21.5c-1.4-2.9-3.9-7.8-5.6-13.2
		c-3.6-10.8,11.8-17.5,17.3-7.5c0,0,0,0,0,0s58.2,119,92.3,119.6c11.7,1.8,30.6,3.8,45.8-3.6c12.3-4.1,24.7-12.3,25.6-36.4
		c0.9-24.1,12.3-80,42.5-103.8c10.3-7.2,15.2-6.3,18.9-3.7c3.7,2.6,3.2,12.3-1.4,22.4s-12.3,53.9-0.3,78.3
		c9.9,20.1,29.4,50.3,35.3,65.4c1.7,4.3,6.3,6.7,10.8,5.7c13.6-3,35.4-10.3,47.8-27.8c15.9-22.4,27.6-39.5,27.6-39.5
		s-22.7,64.4-51.9,72.8c-12.6,3.8-14.2,4.3-23.2,1.1c-11.3-4.1-8.9-1.4-10.5-1.6c-3.1,5.1-7.5,10-11.9,11.2s-17.3,1.4-24.8-1.6
		c-7.6-2.7-9.7-2.6-13.4-2.4c-3.9,0.2-12.1-0.5-19.7-7c-6.7-5.7-12.5-10.4-15.3-13.8c-0.7-0.9-2.6-2.2-3.5-2.8
		c-7-4.4-31.5-18.4-46.5-0.2c-16.3,19.8-30.6,48.4-59.3,40.7C149.9,361,130.9,340.3,120.4,318.5z"
  />
  <linearGradient
    id="SVGID_3_"
    gradientUnits="userSpaceOnUse"
    x1="271.9544"
    y1="193.8372"
    x2="271.9544"
    y2="9.9017"
  >
    <stop offset="0" style="stop-color:#AF955A" />
    <stop offset="0.2102" style="stop-color:#CCAE81" />
    <stop offset="0.4247" style="stop-color:#E5C4A2" />
    <stop offset="0.5417" style="stop-color:#EFCCAF" />
    <stop offset="0.5751" style="stop-color:#EED3BC" />
    <stop offset="0.6447" style="stop-color:#ECDFD0" />
    <stop offset="0.7135" style="stop-color:#EBE6DD" />
    <stop offset="0.7797" style="stop-color:#EBE8E1" />
    <stop offset="0.8567" style="stop-color:#EAEBE7" />
    <stop offset="1" style="stop-color:#EAEDEA" />
  </linearGradient>
  <path
    class="st3"
    d="M272.5,157.9c0,0,33.2,24,57.3-3.2s30.5-21.4,35.1-18.8c4.5,2.6,24.5,9.7,30.8,20.7
		c6.2,11,22.8,36.9,37.8,21.1c15-15.8,26.3-31.7,41.3-7.2c4-22,5.5-42.5,3.7-51.3c9.2,38.1,18.9,67.3,19.3,73.5
		c9.5-17.2,38.3-66.2,10.4-105.8c-8.8-9.9-25.3-23.4-34.9-28.2s-11.7-2.6-10.3,3.7s3.4,14.2,3.4,14.2s0.9,2.9,0,3s-3.5-5.3-3.5-5.3
		s-17.7-38.9-30.3-40c-13.3-4.6-23.5-8.7-26.1-9.3c-2.6-0.6-8.9-2.4-14.7,2.9c-7.9,5-19.7,17.3-19.4,24.7c0.3,2,1.1,4.4,0.3,4.7
		c-0.8,0.3-2.9-4-2.9-4s-19.2-42.3-55-43.5c-35.9,0-51,28.3-51.5,29.9c-0.5,1.7-1.8,10.1-4.7,10.4c-4.1,0.6-6.1-4.3-8.4-8.7
		c-3.7-5-19.4-26.3-35.3-26.1s-29.9,9.3-41.8,30.5c-2.7,5-4.9,10.8-7.3,10.8c-2.4,0-4.1-9.9-4.1-9.9s-5.8-34.8-25.8-30.1
		c-17.6,4.1-32.8,7-39.9,14.5S82.6,45,82,46.7c-1.8-1.2-3.4-1.5-5.3-0.3C74.6,47.6,42,65.3,42,65.3S20.1,79.4,24.6,128
		c6.9,40.2,9.3,41.1,9.3,41.1s10.4,13.5,11.4,1.6s9.6-39.4,13.3-42.4c3.6-3,10.5-1.5,13.9,14c9.1,22.6,22.1,6.4,29,17.3
		c6.9,10.9,19.7,7.2,25.3-5.6s26.9-55.4,29.3-28c7.7,12,8.8,19.4,13.3,16.2c4.5-3.2,7.5-2.7,9.6,6.7c6.9,1.6,12,4.5,20.2,18.6
		c8.3,14.1,29.3,53.2,49.5-3.7C257.2,141.8,272.5,157.9,272.5,157.9z"
  />
</g>

<style>
  * {
    pointer-events: none;
  }
</style>